import { Link } from "react-router-dom";
import { movieCategories } from "@/mocks/movies";

export default function CategorySection() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              电影分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按类型浏览你喜欢的电影</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            全部分类
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3">
          {movieCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200">
                <i className={`${cat.icon} text-primary-500 text-xl`}></i>
              </div>
              <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}